import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Grid, Typography } from "@material-ui/core";
import { getSolicitudesRelacionadas } from "../../../../actions/autorizaciones/Autorizaciones";
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import IconEstado from "../../UI/IconEstado";


const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudesRelacionadasMenu = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {}, solicitudesRelacionadas = [] } = useSelector((state) => state.autorizaciones);

  useEffect(() => {
    if (solicitudSeleccionada.idSolicitud) {
      dispatch(getSolicitudesRelacionadas(solicitudSeleccionada.idSolicitud));
    }
  }, []);

  return (
    <React.Fragment>
      {solicitudesRelacionadas.length > 0 &&
        <Grid item xs={12} md={12} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              withoutPagination
              data={solicitudesRelacionadas}
              columns={[
                {
                  label: "Estado",
                  id: "estado",
                  sort: true,
                  align: "center",
                  customBody: (item) =>
                    <IconEstado
                      useColorTable={true}
                      texto={item?.estadosSolicitud?.letra}
                      backgroundColor={item?.estadosSolicitud?.color}
                      descripcion={item?.estadosSolicitud?.descripcion}
                    />,
                },
                {
                  label: "Fecha enviada",
                  id: "fechaEnviada",
                  sort: true,
                  align: "center",
                  customBody: (item) =>
                    `${item.fechaEnviada !== null ? new Date(item.fechaEnviada).toLocaleString("es", optionsfecha) : ""}`,
                },
                {
                  label: "N° Orden",
                  id: "idSolicitud",
                  sort: true,
                  align: "center",
                  customBody: (item) =>
                    `${item?.idSolicitud}`,
                },
                {
                  label: "Tipo Solicitud",
                  id: "tipoSolicitud",
                  sort: false,
                  align: "center",
                  customBody: (item) =>
                    `${item?.tipoSolicitud?.descripcionTipo}`,
                },
                {
                  label: "Diagnostico",
                  id: "diagnostico",
                  sort: false,
                  align: "center",
                  customBody: (item) =>
                    `${item?.diagnostico?.problema}`,
                },
                {
                  label: "Seccional",
                  id: "seccional",
                  sort: false,
                  align: "center",
                  customBody: (item) =>
                    `${item?.seccional?.descripcion_seccional}`,
                },
                {
                  label: "Bandeja",
                  id: "bandeja",
                  sort: false,
                  align: "center",
                  customBody: (item) =>
                    `${item?.bandejasAutorizacion?.descripcion}`,
                },
              ]}
            />
          </Card>
        </Grid>
      }
      {solicitudesRelacionadas.length === 0 &&
        <div style={{ height: 130, textAlign: "center" }}>
          <Typography align="center">
            No hay Solicitudes relacionadas
          </Typography>
        </div>
      }
    </React.Fragment>
  );
};
